import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import {withRouter, Link} from "react-router-dom";
import { Icon } from 'antd';
import {connect} from "react-redux";
import TopbarMenuLink from './TopbarMenuLink';
import Cookies from "universal-cookie";
import {getUserName, getDisplayName, ApiService} from "../../../services/ApiService1";
import {getAccessToken} from "../../../services/constants";


const Ava = `${process.env.PUBLIC_URL}/img/dashboard-user.png`;

class TopbarProfile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      clientId: props.match.params.clientId,
      displayName: ''
    };
  }

  componentWillMount() {
    this.getUserDetails()
  }

  getUserDetails = async () => {
    if(getUserName() && getAccessToken() && !this.state.displayName && !getDisplayName()) {
      const data = await ApiService.getCurrentUserDetails(getUserName() || "")
      this.setState({
        displayName: (data || {}).USR_DISPLAY_NAME
      })
      localStorage.setItem('user-display-name', (data || {}).USR_DISPLAY_NAME)
    }
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  onLogout = () => {
    const cookies = new Cookies();
    cookies.remove('USER_PWD_TOKEN',  { path: '/' });
    cookies.remove('JWT_ACCESSTOKEN1', { path: '/' });
    cookies.remove('JWT_ACCESSTOKEN2', { path: '/' });
    cookies.remove('REGISTERED_APPNAME', { path: '/' });
    cookies.remove('LOGGEDIN_USERID', { path: '/' });
    cookies.remove('LAST_LOGIN', { path: '/' });
    cookies.remove('USER_ADMIN_ROLE', { path: '/' });

    const newWindow = window.open(this.props.logoutURL, '_blank')
    setTimeout(() => newWindow.close(), 5000);

    setTimeout(() => {
      window.location.reload()
    }, 5100)
  }
  getUserName = () => {
    const cookies = new Cookies();
    let userName = this.state.displayName || getDisplayName() // || cookies.get('LOGGEDIN_USERID') || '';
    // let userName = cookies.get('LOGGEDIN_USERID');
    if (userName.length > 20) {
      userName = userName.substr(0, 20) + '..'
    }
    return userName;
  }

  render() {
    const cookies = new Cookies();
    const { version = '' } = this.props;
    const { collapse, clientId } = this.state;
    const role = cookies.get('USER_ADMIN_ROLE')
    return (
      <div className="topbar__profile">
        <div className="pull-left d-flex" style={{alignItems: 'center', height: '100%'}}>
          <Link to={`/${clientId}/dashboard`} style={{lineHeight: '30px'}} >
            <Icon type="home" className="color-white fs-30" />
          </Link>
        </div>
        <button type="button" className="topbar__avatar" onClick={this.toggle}>
          <img className="topbar__avatar-img" src={Ava} alt="avatar" />
          <p className="topbar__avatar-name"><b>{this.getUserName()}</b></p>
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button type="button" className="topbar__back" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            <span onClick={this.onLogout}>
              <a className="topbar__link"><span className="topbar__link-icon lnr lnr-exit"/><p
                className="topbar__link-title">Log Out</p></a>
            </span>
            <span onClick={this.props.onAboutModalChange}>
              <a className="topbar__link">
                <span className="topbar__link-icon lnr lnr-info"/>
                <p className="topbar__link-title">About Us</p></a>
            </span>
            {/*<TopbarMenuLink title="Admin" icon="user" path={`/${clientId}/admin/applist`}/>*/}
            {/*<TopbarMenuLink title="Certification" icon="user" path={`/${clientId}/certification`} />*/}
            {/*<TopbarMenuLink title="Requests" icon="user" path={`/${clientId}/requests`} />*/}
            {/*<span onClick={this.props.onModalChange}>
              <a className="topbar__link"><span className="topbar__link-icon lnr lnr-exit"/><p
                  className="topbar__link-title">Password Reset</p></a>
            </span>*/}
            {/* { (getUserName() || "").toLowerCase() === "xelsysadm" ? <TopbarMenuLink title="Admin" icon="user" path={`/${clientId}/admin/dashboard`} /> : null } */}
            { role !== "Manager" ? <TopbarMenuLink title="Admin" icon="user" path={`/${clientId}/admin/dashboard`} /> : null }
            { role !== "Manager" ? <TopbarMenuLink title="Certifier" icon="user" path={`/${clientId}/certification`} /> : null }
            {/*<TopbarMenuLink title="Admin" icon="user" path={`/${clientId}/admin/intelligent-identity`} />*/}
            {/*<span>
              <a className="topbar__link">
                <span className="topbar__link-icon lnr lnr-exit"/><p
                  className="topbar__link-title">Version: {version}</p></a>
            </span>*/}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: (state && state.auth && state.auth.info) || {},
  version: (state && state.local && state.local.Version) || "",
  logoutURL: (state && state.local && state.local.logoutURL) || "",
});

export default connect(mapStateToProps, null) (withRouter(TopbarProfile));
